import { Grid } from "@mui/material";
import { whyChooseUsContent } from "../../data/whyChooseUsContent";
import SectionCard from "../common/SectionCard";
import SectionYellowTitle from "../common/SectionYellowTitle";
import SectionMainTitle from "../common/SectionMainTitle";
import ParallaxBackground from "../common/ParallaxBackground";

const WhyChooseUsSection: React.FC = () => {
  return (
    <ParallaxBackground backgroundImage="/assets/ingenieros-m.jpg">
      {/* Sección amarillo pequeño */}
      <SectionYellowTitle title={whyChooseUsContent.subtitle} />

      {/* Título principal */}
      <SectionMainTitle title={whyChooseUsContent.title} mb={5} />

      {/* Cards con Grid responsive */}
      {whyChooseUsContent.sections.map((section, index) => (
        <Grid size={{ xs: 12, md: 6 }} key={index}>
          <SectionCard
            heading={section.heading}
            body={section.body}
            icon={section.icon}
            iconColor={section.iconColor}
            iconBg={section.iconBg}
            highlightColor={section.highlightColor}
          />
        </Grid>
      ))}
    </ParallaxBackground>
  );
};

export default WhyChooseUsSection;
